import React, { useEffect } from "react"
import { useSnackbar } from "notistack"
import { IconButton } from "@material-ui/core"
import CancelIcon from "@material-ui/icons/Cancel"

const useSnackbarNotification = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar()

	const snackbarOptions = {
		variant: "success",
		anchorOrigin: {
			vertical: "top",
			horizontal: "right",
		},
		autoHideDuration: null,
		hideIconVariant: true,
		action: null,
	}

	/**
	 * notificationsFormat = [{
	 *      variant: "success" | "error" | "warning" | "info",
	 *      message: "Here is the message to display",
	 * }]
	 */
	function addSnackbar(notifications = [], delay = 1000) {
		if (notifications.length) {
			notifications.forEach((notification, i) => {
				setTimeout(() => {
					const isError = notification?.variant === "error"
					enqueueSnackbar(notification?.message, {
						...snackbarOptions,
						variant: notification.variant || "success",
						autoHideDuration: isError ? null : 3000,
						hideIconVariant: isError,
						persist: isError,
						action: isError ? (
							(i) => (
								<IconButton key={i} size="small" aria-label="close" color="inherit" onClick={() => closeSnackbar(i)}>
									<CancelIcon fontSize="small" />
								</IconButton>
							)
						) : (
							<></>
						),
						//style: { marginTop: i === 0 && "70px" },
					})
				}, delay * i)
			})
		}
	}

	return {
		addSnackbar,
	}
}

export default useSnackbarNotification
